/** Strings of the reports and sessions pages (the tools over the panel's match reports). */
export const ca_reports = {
  reportsPage2: {
    search: 'Cerca',
    searchPlaceholder: 'Missió o mapa',
    server: 'Servidor',
    allServers: 'Tots',
    status: 'Estat',
    allStatuses: 'Totes',
    from: 'Des de',
    to: 'Fins a',
    filters: 'Filtres',
    onlyPlayed: 'Només les que he jugat',
    played: 'Hi has jugat',
    clearFilters: 'Neteja els filtres',
    showDiscarded: (n: number) =>
      n > 0 ? `Mostra les descartades (${n})` : 'Mostra les descartades',
    showDiscardedHint:
      'Partides que el panell ha descartat o que han acabat sense cap jugador. Els totals compten només el que hi ha a la llista.',
    noMatch: 'Cap partida coincideix amb els filtres.',
    sortBy: (col: string) => `Ordena per ${col.toLowerCase()}`,
    openReportOf: (mission: string) => `Obre l’informe de ${mission}`,

    /**
     * Les taules d'armament que el panell ja compta i que aquí només s'ensenyen:
     * qui va disparar què, què es va conduir i què es va perdre.
     */
    detail: 'Armament i vehicles',
    detailOpen: (mission: string) => `Mostra l’armament de ${mission}`,
    detailClose: 'Amaga l’armament',
    detailLoading: 'Demanant-ho al panell…',
    detailNone: 'El panell no en té les dades d’aquesta partida.',
    weapons: 'Armes',
    vehicles: 'Vehicles',
    destroyed: 'Vehicles perduts',
    colWeapon: 'Arma',
    colShots: 'Trets',
    colWeaponKills: 'Baixes',
    colUsers: 'Qui la va fer servir',
    colVehicle: 'Vehicle',
    colTime: 'Temps',
    colDistance: 'Distància',
    colDestroyed: 'Destruïts',
    colFriendly: 'Per foc amic',
    colDestroyers: 'Qui els va destruir',
    byAi: 'La IA',
    tasks: 'Objectius',
    taskStates: {
      SUCCEEDED: 'Assolit',
      FAILED: 'Fallit',
      CANCELED: 'Cancel·lat',
      ASSIGNED: 'Obert',
      CREATED: 'Obert',
    } as Record<string, string>,
    killFeed: 'Baixes',
    killFeedOf: (n: number) => `Les últimes ${n}`,
    friendlyFire: 'Foc amic',
    suicide: 'Ell mateix',
    metres: (m: number) => `${m} m`,
    minutes: (n: number) => `${n} min`,
    kilometres: (m: number) => (m >= 1000 ? `${(m / 1000).toFixed(1)} km` : `${m} m`),
    stats: {
      matches: 'Partides',
      played: 'Que has jugat',
      hours: 'Hores jugades',
    },
  },
  sessionsPage2: {
    search: 'Cerca',
    searchPlaceholder: 'Missió, mapa o servidor',
    filters: 'Filtres',
    onlyPlayed: 'Només les que he jugat',
    smokeNights: 'Nits de fum',
    tests: 'Mostra les proves',
    testsCount: (n: number) => `Mostra les proves (${n})`,
    testsHint:
      'Nits de fum, gires d’inspecció i sessions de proves guiades: la feina de la plataforma, no nits que hagi jugat el grup. Només les veu un administrador.',
    testChip: 'prova',
    smokeNight: 'Nit de fum',
    smokeNightHint:
      'Nit de prova que la plataforma ha jugat sola per comprovar-se; no surt a la llista si no es demana.',
    played: 'Hi has jugat',
    fromPanel: 'Del panell',
    fromPanelHint: 'Partida jugada al servidor sense sessió a la plataforma.',
    fromPlatform: 'De la plataforma',
    fromPlatformHint:
      'Partida d’una missió feta amb la plataforma; la sessió o la missió ja no hi són i en queda l’informe del panell.',
    select: 'Selecciona',
    selectDone: 'Surt de la selecció',
    selectAll: (n: number) => `Selecciona-les totes (${n})`,
    selectNone: 'Cap',
    selectCard: (title: string) => `Selecciona la sessió de «${title}»`,
    alsoReports: 'Esborra també l’informe del panell',
    deleteMany: (n: number) => (n === 1 ? 'Esborra 1 sessió' : `Esborra ${n} sessions`),
    deleteManyTitle: (n: number) =>
      n === 1 ? 'Esborrar la sessió seleccionada?' : `Esborrar les ${n} sessions seleccionades?`,
    deleteManyBody: (reports: boolean) =>
      reports
        ? 'S’esborren les nits i tot el que en penja, i també els informes i les estadístiques que en té el panell. Les missions no es toquen. No es pot desfer.'
        : 'S’esborren les nits i tot el que en penja. Les missions i els informes del panell no es toquen; una partida amb informe continuarà sortint a la llista. No es pot desfer.',
    deleting: (done: number, total: number) => `Esborrant ${done} de ${total}…`,
    deleteFailed: (n: number) =>
      n === 1 ? 'Una sessió no s’ha pogut esborrar.' : `${n} sessions no s’han pogut esborrar.`,
    noTerrain: 'Sense mapa',
    open: 'Obre la sessió',
    briefing: 'Briefing',
    report: 'Informe',
    pdf: 'PDF',
    onlyMineHint:
      'De les sessions jugades, només hi surten aquelles en què has participat, per la teva identitat de Steam.',
    noMatch: 'Cap sessió coincideix amb els filtres.',
    delete: 'Esborra',
    deleteLabel: (title: string) => `Esborra la sessió de «${title}»`,
    deleteTitle: (title: string) => `Esborrar la sessió de «${title}»?`,
    deleteBody:
      'S’esborra la nit i tot el que en penja: els esdeveniments, les ordres, les votacions i les lectures del briefing. La missió i, si n’hi ha, l’informe del panell no es toquen. No es pot desfer.',
    deleteConfirm: 'Esborra la sessió',
    deleteLiveHint: 'Una sessió en curs no es pot esborrar; acaba-la primer.',
  },
} as const;
